import React, { useState } from 'react';
import { fmtQty, unitLabel } from '../utils/format';
import Alert from './Alert';

export default function StockModal({ product, type, onCancel, onConfirm }) {
  const isLoose = !!product.is_loose;
  const [qty, setQty] = useState(isLoose ? '' : 1);
  const [note, setNote] = useState('');
  const [error, setError] = useState('');

  function handleConfirm() {
    const q = isLoose ? parseFloat(qty) : parseInt(qty, 10);
    if (!q || q <= 0) {
      setError(`Enter a valid quantity${isLoose ? ` in ${product.unit}` : ''}.`);
      return;
    }
    if (type === 'minus' && q > parseFloat(product.qty)) {
      setError('Cannot remove more than available stock.');
      return;
    }
    onConfirm(type, q, note);
  }

  const unitSuffix = isLoose ? ` (${unitLabel(product.unit)})` : '';

  return (
    <div
      className="modal-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onCancel();
      }}
    >
      <div className="modal" style={{ width: 420 }}>
        <div className="modal-header">
          <div className="modal-title">
            {type === 'add' ? 'Add Stock' : 'Remove Stock'} — {product.name}
          </div>
          <button className="btn btn-sm" onClick={onCancel}>
            <i className="ti ti-x" aria-hidden="true"></i>
          </button>
        </div>
        <div className="modal-body">
          <Alert type="danger" message={error} onClose={() => setError('')} />
          <p style={{ fontSize: 12, color: 'var(--text2)', marginBottom: '1rem' }}>
            Current stock: <strong>{fmtQty(product.qty, product.unit)}</strong>
          </p>
          <div className="form-group">
            <label className="form-label">Quantity to {type === 'add' ? 'add' : 'remove'}{unitSuffix}</label>
            <input
              type="number"
              min={isLoose ? '0.001' : '1'}
              step={isLoose ? '0.001' : '1'}
              value={qty}
              placeholder={isLoose ? 'e.g. 0.500' : ''}
              onChange={(e) => {
                const v = e.target.value;
                setQty(isLoose ? v : v.replace(/\.\d*/, ''));
              }}
            />
          </div>
          <div className="form-group">
            <label className="form-label">Note (optional)</label>
            <input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Reason for adjustment…" />
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn" onClick={onCancel}>
            Cancel
          </button>
          <button className={`btn ${type === 'add' ? 'btn-primary' : 'btn-danger'}`} onClick={handleConfirm}>
            <i className="ti ti-check" aria-hidden="true"></i>Confirm
          </button>
        </div>
      </div>
    </div>
  );
}
